// Shared config/labels for the tickets (print jobs) dashboard.

export const STATUS_CONFIG = {
  printed: { label: 'Impreso', color: 'success' },
  reprinted: { label: 'Reimpreso', color: 'info' },
  failed: { label: 'Fallido', color: 'error' },
};

export const STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'printed', label: 'Impreso' },
  { value: 'failed', label: 'Fallido' },
  { value: 'reprinted', label: 'Reimpreso' },
];

const PRINTER_TYPE_LABELS = {
  pdf: 'PDF',
  network: 'Red',
  usb: 'USB',
};

export const printerTypeLabel = (type) => PRINTER_TYPE_LABELS[type] || type || '—';

export const PRINTER_TYPE_COLORS = {
  pdf: 'default',
  network: 'primary',
  usb: 'secondary',
};
